import { OnInit, Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { loadLocal } from '../../helpers/helpers';
import { listDifference, listUnion } from 'globals/helpers/helpers';
import { tableFilterTypes } from 'src/app/store/performers.era';
import { attendeeColumnsById } from 'src/app/helpers/table-helpers';
import { JoiEvent, Label, LabelObject } from 'globals/store/events.data';
import { AttendeeTableData, attendeeTableColumns } from 'src/app/helpers/table-column-types';
import { TableColumn, TableMenuItem } from 'src/app/helpers/table.data';
import { attendeeColumnsReselector } from 'src/app/store/reselectors/performers.reselector';
import { addAnAttendee, chooseOrAddEntityTypes, ChooseOrAddTypesData, importTableData, saveTable } from '../performers/performerSharedFunctions';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { NestedTableComponent } from 'src/app/components/nested-table/nested-table.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { LabelUpdateFunctionParams } from '../../components/label-marker/label-maker.dialog.component';
import { addLabelsToMany, removeLabelsFromMany } from '../../helpers/label-helpers';
import { Attendee } from 'globals/store/attendees.data';
import { attendeeTableReselector } from '../../store/reselectors/attendees.reselector';
import { ManageAttendeeData, ManageAttendeeDialogComponent } from './manage-attendee.component';
import { EntitySubTable, subTableNames } from 'globals/store/entity.data';
import { AttendeesService } from '../../services/attendees.service';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CustomQuestionAnswersComponent } from 'src/app/components/entities/custom-questions-answers.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { JoiNavWrapper } from 'src/app/components/wrappers/joi-nav-wrapper.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { CommonModule, DatePipe } from '@angular/common';
@Component({
    selector: 'attendees-table',
    template: `
<top-menu></top-menu>
<mobile-menu></mobile-menu>
<joi-nav-wrapper 
  class="icon-tabs"
  [simple]="true"
  [menuItems]="subTables"
  [menuMap]="subTableNames"
  [selectedId]="subTable" 
  (selectItem)="subTable = $event"
></joi-nav-wrapper>
<custom-question-answers *ngIf="subTable === 'responses'" [entityType]="'attendee'"></custom-question-answers>
<command-menu
  *ngIf="subTable !== 'responses'"
  [filterPage]="filterPage"
  [filterType]="filterType"
  [filterText]="'Filter attendees'"
  [showDottedMenu]="true"
  [showExport]="true"
  [showImport]="true"
  [canEditColumns]="true"
  [addItemText]="!event || event.is_readonly ? '' : '+ ADD AN ATTENDEE'"
  (addItem)="addAnAttendee($event)"
  (onExport)="saveTable()"
  (onImport)="importTableData()"
></command-menu>
<nested-table
  *ngIf="subTable !== 'responses'"
  [items]="tableData"
  [filtersId]="filterPage"
  [condensedView]="condensed"
  [columns]="columnData"
  [columnsById]="columnsById"
  [menuItems]="menuItems"
  [menuDisabled]="busy"
  [defaultSelectedColumnId]="attendeesColumns.name"
  [readOnly]="!!event?.is_readonly"
  [emptyMessage]="'No attendees in this event'"
  (selectItem)="manageAttendee($event)"
  (updatedSelectedIds)="selectIds($event)"
></nested-table>
<loader-pane-fragment [trace]="traceNames.viewAttendees"></loader-pane-fragment>
`,
    styleUrls: ['../../page.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [LoaderPaneFragmentComponent, CommonModule, CommandMenuComponent, CustomQuestionAnswersComponent, NestedTableComponent, TopMenuComponent, MobileMenuComponent, JoiNavWrapper, ],
})
export class AttendeesTableComponent extends Wrapper<AttendeesTableComponent> implements OnInit {
  filterPage = filterPageTypes.attendees
  filterType = tableFilterTypes.attendeesTable
  subTable: EntitySubTable = 'attendees'
  subTables: EntitySubTable[] = ['attendees', 'responses' ]
  traceNames = traceNames;
  subTableNames = subTableNames

  attendeesColumns = attendeeTableColumns
  columnData: TableColumn[] = []
  columnsById: { [id: string]: TableColumn } = attendeeColumnsById
  tableData: AttendeeTableData[] = []
  tableRowsById: { [id:string]: AttendeeTableData } = {}
  allMenuItems: TableMenuItem[] = [
    { title: 'Delete', method: this.deleteAttendees.bind(this) }
  ]
  menuItems: TableMenuItem[] = this.allMenuItems
  condensed: boolean
  event: JoiEvent
  selectedIds: string[] 
  attendee_labels: LabelObject = {}
  busy = false

  @ViewChild(NestedTableComponent) nestedTable: NestedTableComponent<AttendeeTableData>
  saveTable() {
    saveTable('attendee', `${this.event.title} attendees table`, this.dialog, this.nestedTable)
  }
  importTableData(){
    importTableData('attendee', this.dialog, this.attendeeService.addMultipleAttendees.bind(this.attendeeService))
  }



  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.uiService.changePageTitle("Attendees", true)
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('events', 'labelMaps', 'attendee_labels'), 'attendee_labels')
    this.subCallback(this.store.select(attendeeTableReselector), data => {
      if (!data) {
        this.tableData = [] // for when the last is deleted
        return
      }
      const { tableData, tableRowsById } = data
      this.tableData = tableData
      this.tableRowsById = tableRowsById
    })
    this.loadCondensed()
    this.subCallback(this.store.select('filters', 'toggleFilters', this.filterPage, 'condensed'), _ => this.loadCondensed())
  }

  ngOnInit() {
    this.subProp(this.store.select(attendeeColumnsReselector), 'columnData')
  }

  selectIds(ids: Set<string>) {
    this.selectedIds = Array.from(ids)
    // console.log(this.selectedTaskIds)
    setTimeout(() => this.buildMenu(), 0)
  }

  private get selectedAttendees(): Attendee[] {
    return (this.selectedIds || []).map(id => this.tableRowsById[id].attendee)
  }

  buildMenu() {
    const attendees = this.selectedAttendees
    const n = attendees.length
    this.menuItems = []
    this.menuItems.push({ title: 'Add labels', method: this.addLabels.bind(this) })
    if (attendees.some(a => a.labels?.length)) this.menuItems.push({ title: 'Remove labels', method: this.removeLabels.bind(this) })

    this.menuItems.push({ title: 'Change type', method: this.changeType.bind(this) })
    if (attendees.some(a => !a.confirmed)) this.menuItems.push({ title: 'Confirm', method: this.confirm.bind(this) })
    if (attendees.some(a => !!a.confirmed)) this.menuItems.push({ title: 'Unconfirm', method: this.unconfirm.bind(this) })
    this.menuItems.push({ title: 'Delete', method: this.deleteAttendees.bind(this) })      
    // this.menuItems.push({ title: 'Add to clipboard', method: this.addToClipboard.bind(this) })  
  }

  async confirm() {
    const attendees = this.selectedAttendees.filter(a => !a.confirmed)
    attendees.forEach(a => a.confirmed = true)
    this.attendeeService.updateAttendees(attendees)
    this.nestedTable.unselectAll()
  }

  async unconfirm() {
    const attendees = this.selectedAttendees.filter(a => !!a.confirmed)
    attendees.forEach(a => a.confirmed = false)
    this.attendeeService.updateAttendees(attendees)
    this.nestedTable.unselectAll()
  }

  async changeType(_, event) {
    const parent = event.target.parentElement
    const rect = parent.getBoundingClientRect()

    const position = { top: rect.bottom - 2, left: rect.left }
    const data: ChooseOrAddTypesData<AttendeesService, Attendee> = {
      position, 
      dialog: this.dialog, 
      entityService: this.attendeeService, 
      types: this.event.attendeeTypes,
      entities: [...this.selectedAttendees],
      single: false,
      typeName: 'Attendee',
      isCategory: true
    }
    console.log(data)
    await chooseOrAddEntityTypes(data)
    this.nestedTable.unselectAll()
  }

  async addToClipboard() {
    this.busy = true
    await this.attendeeService.templateAttendees(this.selectedAttendees)
    this.busy = false
    const n = this.selectedAttendees.length
    this.nestedTable.setMessage(`Templates for ${n} attendeee${n > 1 ? 's' : ''} added to the clipboard.`)
    this.nestedTable.unselectAll()
  }

  public async updateLabelTemplate(labels: Label[]) {
    labels.forEach(label => this.attendee_labels[label.id] = label) // need to overwrite the old values here to both maintain order and propagate changes without losing filtered out template labels
    await this.eventService.updateEvent(this.eventService.eventId, { attendee_labels: Object.values(this.attendee_labels) })
  }

  public async addLabelsUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsChanged) this.updateLabelTemplate(labelTemplate)

    if (!labelsToggled) return
    const attendees = this.selectedAttendees
      .filter(s => !s.labels || labels.some(label => !s.labels.includes(label)))
      .map(s => ({...s, labels: listUnion(s.labels, labels) }))
    
    await this.attendeeService.updateAttendees(attendees)
    this.buildMenu()
  }

  public async removeLabelsUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsChanged) this.updateLabelTemplate(labelTemplate)

    if (!labelsToggled) return
    const filteredLabels = labelTemplate.map(l => l.id).filter(id => !labels.includes(id))
    if (filteredLabels.length === 0) return

    const attendees = this.selectedAttendees
      .filter(s => s.labels && s.labels.some(label => filteredLabels.includes(label)))
      .map(s => ({...s,  labels: listDifference(s.labels, filteredLabels) }))

    await this.attendeeService.updateAttendees(attendees)
    this.buildMenu()    
  }

  async removeLabels(_, event) { 
    removeLabelsFromMany(this.removeLabelsUpdateFunction.bind(this), this.attendee_labels, this.dialog, 'attendee', this.selectedAttendees, event)
  }

  async addLabels(_, event) { 
    addLabelsToMany(this.addLabelsUpdateFunction.bind(this), this.attendee_labels, this.dialog, 'attendee', this.selectedAttendees, event)
  }



  async deleteAttendees(toDelete: AttendeeTableData[], event) {
    const data: ConfirmDeleteData = {
      title: `Delete ${toDelete.length} attendees`,
      rect: event.target.getBoundingClientRect(),
      para: `Are you sure you want to delete ${toDelete.length > 1 ? `all ${toDelete.length} selected attendees` : 'the selected attendee'}?`,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.busy = true
    await this.attendeeService.deleteAttendees(toDelete.map(r => r.attendee))
    this.busy = false
  }

  addAnAttendee(event) {
    addAnAttendee(event, this.dialog, this.attendeeService, this.manageAttendee.bind(this))
  }


  async manageAttendee({ id }: AttendeeTableData) {
    this.changeDetectorRef.detach()
    console.log("Should be managing attendee", id)

    const data: ManageAttendeeData = { attendeeId: id, readOnly: !this.event || this.event.is_readonly }
    await openDialogGetResult(this.dialog, ManageAttendeeDialogComponent, { disableClose: true, autoFocus: false, data, panelClass:  'full-screen-modal' })
    
    this.changeDetectorRef.reattach()
  }

  loadCondensed() {
    this.condensed = loadLocal(`${this.filterPage}:${toggleFilterTypes.condensed}`, false)
  }
}
